import { ToroControllerBundle } from './../../../api/models/toro-controller-bundle';
// import { ToroLocationDetailed } from './../../api/models/toro-location-detailed.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ToroController } from './../../../api/models/toro-controller.model';
import { ToroControllerConfiguration } from './../../../api/models/toro-controller-configuration.model';
import { CommCardDetailed } from './../../../api/models/comm-card/comm-card-detailed.model';
import { ToroStation } from './../../../api/models/toro-station.model';

export const controllerAdapter: EntityAdapter<ToroControllerBundle> = createEntityAdapter<ToroControllerBundle>({
    selectId: (controller: ToroControllerBundle) => controller.Controller.Id
});

export interface ControllerState extends EntityState<ToroControllerBundle> {
    total: number;
    loaded: boolean;
    selectedController: ToroController;
    selectedControllerConfiguration: ToroControllerConfiguration;
    selectedControllerComCard: CommCardDetailed;
    currentController: ToroController;
    currentStation: ToroStation;
    controllerList: ToroController[];
    controllerConfigurationList: Map<number, ToroControllerConfiguration>;
    controllerCommcardList: Map<number, CommCardDetailed>;
    ids: number[];
}
